import realLinkifyElement from 'linkifyjs/element'

export const linkifyElement = (el) => {
  realLinkifyElement(el)
}



// WEBPACK FOOTER //
// ./~/vue-components/utils/linkify.js